export default {
  title: 'Overlappende aanbieding in dezelfde periode',
  buttons: {
    save_as_active: 'Instellen als nieuwe actieve aanbieding',
    save_as_inactive: 'Opslaan als Inactief',
    cancel: 'Annuleren',
  },
  description: {
    base: '{{offer}} overlapt met de actieve aanbieding {{overlappingOffer}} op {{weekday}}{{between}}. U kunt slechts één aanbieding tegelijk uitvoeren in dezelfde periode.',
    between: ', tussen {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Hoe op te lossen: kies een optie hieronder.',
  },
};
